import debounce from 'lodash.debounce';
import moment from 'moment';
import React from 'react';
import { Button, Col, Container, Form, Image, Row, Tab, Tabs } from 'react-bootstrap';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { ToastContainer, toast } from 'react-toastify';
import { LoaderComponente } from "../../Components/LoaderComponente";
import { NavBarComponente } from '../../Components/NavBarComponente';
import "../../Estilo/Form.css";
import fechar from '../../Imagens/close-24.png';
import salvar from '../../Imagens/save-16.png';
import { FormEvent } from '../../ScreenGeneric/Models/FormEvent';
import { VisitViewModel } from './VisitViewModel';

interface MyProps {
    navigation: any
    delegate: VisitViewControllerDelegate
    viewModel: VisitViewModel
    idPrimary: number
    idPoint?: number
    idShape?: number
    idAdminProcess?: number
    idProperty?: number
    idPropertyBuilding?: number
}

export interface VisitViewControllerDelegate {
    tapDimiss(navigation: any): void
}

interface Analisado {
    id: number;
    quantidade: string | number;
    sgepfasedengue: { value: number } | null;
    sgepdengueespecie: { value: number } | null;
    sgepitensinspecaodengue: { value: number } | null;
}


export class VisitViewController extends React.Component<MyProps> {

    private formEvent: FormEvent
    state = {
        isLoading: false,
        json: {},
        professional: Array<any>(),
        visitReason: Array<any>(),
        groupVisitReason: Array<any>(),
        localityName: Array<any>(),
        localityCategory: Array<any>(),
        localType: Array<any>(),
        propertyType: Array<any>(),
        visitType: Array<any>(),
        poison: Array<any>(),
        municipality: Array<any>(),
        activity: Array<any>(),
        pendencyReason: Array<any>(),
        itensToInspect: Array<any>(),
        zona: Array<any>(),
        tubitType: Array<any>(),
        especies: Array<any>(),
        amostras: Array<any>(),
        supervisor: Array<any>(),
        laboratories: Array<any>(),
        trap: Array<any>(),

        laboratoryAnalyzed: false,
        isEndemic: false,
        sgepusuariocargo: null,
        includeAssistants: false,
        analisados: [] as Analisado[],
    }

    constructor(props: any) {
        super(props)
        this.formEvent = new FormEvent(this)
    }

    componentDidMount() {
        this.setKeyFK()
        this.loadProfessional()
        this.loadGroupVisitReason()

        if (this.props.idPrimary > 0) {
            this.loadStruct()
        }
    }
    private getSelectedOption(value: string | number) {
        return this.state.poison.find((opt: any) => opt.value === value) || null;
    };

    render() {
        var json = this.state.json as any
        return (
            <div>
                <NavBarComponente propNav={this.props.navigation} />
                <div>
                    <Container fluid={true}>
                        <Row>
                            <Col>
                                <div className="title">
                                    <h3>Visita</h3>
                                </div>
                                <div className="buttonClose">
                                    <Image className="imageClose"
                                        onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)}
                                        src={fechar} />
                                </div>
                            </Col>
                        </Row>
                        <Form className="containerForm">
                            <Row>
                                <Col lg="4" xs="12" className="bottom10 hide">
                                    <Form.Label>Sequencial</Form.Label>
                                    <Form.Control
                                        id="sgepvisita"
                                        defaultValue={json['sgepvisita'] ? json['sgepvisita'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("inteiro", e.target)}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Data</Form.Label>
                                    <Form.Control
                                        id="data"
                                        maxLength={10}
                                        defaultValue={json['data'] ? json['data'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("date", e.target)}
                                        placeholder="Digite a data"
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Hora</Form.Label>
                                    <Form.Control
                                        id="hora"
                                        maxLength={5}
                                        defaultValue={json['hora'] ? json['hora'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("hour", e.target)}
                                        placeholder="Digite a hora"
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Profissional</Form.Label>
                                    <Select
                                        id="sgepusuariocargo"
                                        value={this.formEvent.onValueSelect('select', 'sgepusuariocargo', this.state.professional)}
                                        onChange={(e: any) => {
                                            const selectedPrincipal = e?.value ?? null;
                                            this.setState((prev: any) => {
                                                const currentAssistants = prev.json.agentAssistants ? prev.json.agentAssistants : [];
                                                const updatedAssistants = currentAssistants.filter(
                                                    (agent: any) => agent.value !== selectedPrincipal
                                                );
                                                return {
                                                    json: {
                                                        ...prev.json,
                                                        sgepusuariocargo: selectedPrincipal,
                                                        agentAssistants: updatedAssistants,
                                                    },
                                                };
                                            }, () => {
                                                this.formEvent.onChange("select", e, "sgepusuariocargo");
                                            });
                                        }}
                                        closeMenuOnSelect={true}
                                        placeholder="Selecione"
                                        options={this.state.professional}
                                        isMulti={false}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Grupo Motivo Visita</Form.Label>
                                    <Select
                                        id="sgepgrupomotivovisita"
                                        value={this.formEvent.onValueSelect('select', 'sgepgrupomotivovisita', this.state.groupVisitReason)}
                                        onChange={(e: any) => this.onChangeGroupVisitReason(e)}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.groupVisitReason}
                                        isMulti={false}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label>Motivo Visita</Form.Label>
                                    <Select
                                        id="sgepmotivovisita"
                                        value={this.formEvent.onValueSelect('select', 'sgepmotivovisita', this.state.visitReason)}
                                        onChange={(e: any) => this.onChangeVisitReason(e)}
                                        closeMenuOnSelect={true}
                                        placeholder={"Selecione"}
                                        options={this.state.visitReason}
                                        isMulti={false}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" className="bottom10">
                                    <Form.Label>Observação</Form.Label>
                                    <Form.Control
                                        id="obs"
                                        as="textarea"
                                        rows={3}
                                        defaultValue={json['obs'] ? json['obs'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                        placeholder="Digite uma observação"
                                    />
                                </Col>
                            </Row>
                            {this.state.isEndemic &&
                                <Tabs defaultActiveKey="geral" className="mb-3">
                                    <Tab eventKey="geral" title="Geral">
                                        <Row className='mx-1'>
                                            <Col lg="4" xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Municipio</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    defaultOptions
                                                    loadOptions={this.loadMunicipalities}
                                                    onChange={(e: any) => this.formEvent.onChange("select", e, "ccidade")}
                                                    placeholder="Pesquise e Selecione"
                                                    isMulti={false}
                                                    value={this.state.municipality?.find((m: any) => m.value === (this.state.json as any)?.ccidade) || null}

                                                />
                                            </Col>
                                            <Col lg="4" xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Nome Localidade</Form.Label>
                                                <Select
                                                    id="sgepnomelocalidade"
                                                    value={this.formEvent.onValueSelect('select', 'sgepnomelocalidade', this.state.localityName)}
                                                    onChange={(e: any) => this.formEvent.onChange("select", e, "sgepnomelocalidade")}
                                                    closeMenuOnSelect={true}
                                                    placeholder={"Selecione"}
                                                    options={this.state.localityName}
                                                    isMulti={false}
                                                />
                                            </Col>
                                            <Col lg="4" xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Categoria Localidade</Form.Label>
                                                <Select
                                                    id="sgepcategorialocalidade"
                                                    value={this.formEvent.onValueSelect('select', 'sgepcategorialocalidade', this.state.localityCategory)}
                                                    onChange={(e: any) => this.formEvent.onChange("select", e, "sgepcategorialocalidade")}
                                                    closeMenuOnSelect={true}
                                                    placeholder={"Selecione"}
                                                    options={this.state.localityCategory}
                                                    isMulti={false}
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Zona</Form.Label>
                                                <Select
                                                    id="sgepzona"
                                                    value={this.formEvent.onValueSelect('select', 'sgepzona', this.state.zona)}
                                                    onChange={(e: any) => this.formEvent.onChange("select", e, "sgepzona")}
                                                    closeMenuOnSelect={true}
                                                    placeholder={"Selecione"}
                                                    options={this.state.zona}
                                                    isMulti={false}
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="bottom10">
                                                <Form.Label className='isRequired'>Tipo Local</Form.Label>
                                                <Select
                                                    id="sgeptipolocal"
                                                    value={this.formEvent.onValueSelect('select', 'sgeptipolocal', this.state.localType)}
                                                    onChange={(e: any) => this.formEvent.onChange("select", e, "sgeptipolocal")}
                                                    closeMenuOnSelect={true}
                                                    placeholder={"Selecione"}
                                                    options={this.state.localType}
                                                    isMulti={false}
                                                />
                                            </Col>

                                            <Col lg="2" xs="12" className="bottom10 text-center">
                                                <Form.Label>Bairro Concluído</Form.Label>
                                                <Form.Check
                                                    id="concluido"
                                                    type="checkbox"
                                                    checked={json['concluido'] === true || json['concluido'] === 'S'}
                                                    onChange={(e: any) => {
                                                        const checked = e.target.checked;
                                                        this.setState((prev: any) => ({
                                                            json: {
                                                                ...prev.json,
                                                                concluido: checked ? 'S' : 'N',
                                                            },
                                                        }));
                                                    }}
                                                />

                                            </Col>
                                            <Col lg="3" xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Ciclo</Form.Label>
                                                <Form.Control
                                                    id="ciclo"
                                                    value={json['ciclo'] || ''}
                                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                    placeholder='Digite o ciclo'
                                                />
                                            </Col>
                                            <Col lg="3" xs="12" className="bottom10">
                                                <Form.Label className='isRequired'>Ano</Form.Label>
                                                <Form.Control
                                                    id="ano"
                                                    value={json?.ano ?? moment().format('YYYY')}
                                                    disabled
                                                />
                                            </Col>
                                            <Col lg="4" xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Atividade</Form.Label>
                                                <Select
                                                    id="sgepatividadedengue"
                                                    value={this.formEvent.onValueSelect('select', 'sgepatividadedengue', this.state.activity)}
                                                    onChange={(e: any) => this.formEvent.onChange("select", e, "sgepatividadedengue")}
                                                    closeMenuOnSelect={true}
                                                    placeholder={"Selecione"}
                                                    options={this.state.activity}
                                                    isMulti={false}
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Número Quadra</Form.Label>
                                                <Form.Control
                                                    id="numeroquadra"
                                                    value={json['numeroquadra'] ?? ''}
                                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                    placeholder="Digite o número da quadra"
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Lado</Form.Label>
                                                <Form.Control
                                                    id="lado"
                                                    type="number"
                                                    min={0}
                                                    defaultValue={json['lado'] ? json['lado'] : ''}
                                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                    placeholder="Digite o lado"
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="bottom10 text-center ">
                                                <Form.Label>Sem Número</Form.Label>
                                                <Form.Check
                                                    id="sem_numero"
                                                    type="checkbox"
                                                    checked={json['sem_numero'] || false}
                                                    disabled={json['numero'] ? true : false}
                                                    onChange={(e: any) => {
                                                        let checked = e.target.checked;
                                                        this.setState((prev: any) => ({
                                                            json: {
                                                                ...prev.json,
                                                                sem_numero: checked,
                                                            },
                                                        }));
                                                    }}
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="bottom10">
                                                <Form.Label>Número</Form.Label>
                                                <Form.Control
                                                    id="numero"
                                                    type="number"
                                                    min={0}
                                                    defaultValue={json['numero'] ? json['sem_numero'] ? '' : json['numero'] : ''}
                                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                    placeholder="Digite o número"
                                                    disabled={json['sem_numero'] ? true : false}
                                                />
                                            </Col>
                                            <Col lg="4" xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Logradouro</Form.Label>
                                                <Form.Control
                                                    id="logradouro"
                                                    defaultValue={json['logradouro'] ? json['logradouro'] : ''}
                                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                    placeholder="Digite o logradouro"
                                                />
                                            </Col>

                                            <Col lg="2" xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Sequencia Imóvel</Form.Label>
                                                <Form.Control
                                                    id="indice_imovel"
                                                    type="text"
                                                    defaultValue={json['indice_imovel'] ? json['indice_imovel'] : ''}
                                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                    placeholder="Digite a quantidade de imóveis"
                                                />
                                            </Col>
                                            <Col lg="3" xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Complemento</Form.Label>
                                                <Form.Control
                                                    id="complemento"
                                                    type='text'
                                                    defaultValue={json['complemento'] ?? ''}
                                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                    placeholder="Digite o complemento"
                                                />
                                            </Col>
                                            <Col lg="3" xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Tipo de Imóvel</Form.Label>
                                                <Select
                                                    id="sgeptipoimovel"
                                                    value={this.formEvent.onValueSelect('select', 'sgeptipoimovel', this.state.propertyType)}
                                                    onChange={(e: any) => this.formEvent.onChange("select", e, "sgeptipoimovel")}
                                                    closeMenuOnSelect={true}
                                                    placeholder={"Selecione"}
                                                    options={this.state.propertyType}
                                                    isMulti={false}
                                                />
                                            </Col>
                                            <Col lg="3" xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Tipo de Visita</Form.Label>
                                                <Select
                                                    id="sgeptipovisita"
                                                    value={this.formEvent.onValueSelect('select', 'sgeptipovisita', this.state.visitType)}
                                                    onChange={(e: any) => this.formEvent.onChange("select", e, "sgeptipovisita")}
                                                    closeMenuOnSelect={true}
                                                    placeholder={"Selecione"}
                                                    options={this.state.visitType}
                                                    isMulti={false}
                                                />
                                            </Col>
                                            <Col lg="3" xs="12" className="bottom10">
                                                <Form.Label>Pendência</Form.Label>
                                                <Select
                                                    id="sgepdenguependencia"
                                                    value={this.formEvent.onValueSelect('select', 'sgepdenguependencia', this.state.pendencyReason)}
                                                    onChange={(e: any) => this.formEvent.onChange("select", e, "sgepdenguependencia")}
                                                    closeMenuOnSelect={true}
                                                    placeholder={"Selecione"}
                                                    options={this.state.pendencyReason}
                                                    isMulti={false}
                                                />
                                            </Col>
                                        </Row>
                                    </Tab>
                                    <Tab eventKey="depositos_inspecionados" title="Criadouros de Risco">
                                        <Row className="mx-1">
                                            {/* Checkbox de inspecionado */}
                                            <Col lg="2" xs="12" className="mt-2 mb-4">
                                                <Form.Check
                                                    id="inspecionado"
                                                    type="checkbox"
                                                    label="Inspecionado"
                                                    checked={json['inspecionado'] || false}
                                                    onChange={(e: any) => {
                                                        const checked = e.target.checked;
                                                        this.setState((prev: any) => ({
                                                            json: { ...prev.json, inspecionado: checked },
                                                        }));
                                                    }}
                                                />
                                            </Col>

                                            {/* Checkbox de analisado */}
                                            <Col lg="10" xs="12" className="mt-2 mb-4">
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Analisado em laboratório"
                                                    checked={this.state.laboratoryAnalyzed}
                                                    onChange={() => {
                                                        this.setState({
                                                            laboratoryAnalyzed: !this.state.laboratoryAnalyzed,
                                                            analisados: !this.state.laboratoryAnalyzed
                                                                ? [
                                                                    {
                                                                        id: 1,
                                                                        quantidade: '',
                                                                        sgepfasedengue: null,
                                                                        sgepdengueespecie: null,
                                                                        sgepitensinspecaodengue: null,
                                                                    }
                                                                ]
                                                                : []
                                                        });
                                                    }}
                                                />

                                            </Col>

                                            {this.state.laboratoryAnalyzed && (
                                                <>
                                                    {this.state.analisados?.map((row: any, index: number) => (
                                                        <Col lg={12} key={row.id}>
                                                            <Row>
                                                                <Col lg={12} className="mt-3 d-flex justify-content-between align-items-center">
                                                                    <label className="m-0">Criadouro nº {index + 1}</label>
                                                                </Col>

                                                                <Col lg="2" xs="12" className="mb-2">
                                                                    <Form.Label className="isRequired">Quantidade</Form.Label>
                                                                    <Form.Control
                                                                        id={`quantidade_${row.id}`}
                                                                        type="number"
                                                                        min={0}
                                                                        value={row.quantidade || ''}
                                                                        onChange={(e: any) => {
                                                                            const analisados = [...this.state.analisados];
                                                                            analisados[index].quantidade = e.target.value;
                                                                            this.setState({ analisados });
                                                                        }}
                                                                        placeholder="Digite a quantidade"
                                                                    />
                                                                </Col>

                                                                <Col lg="3" xs="12" className="mb-2">
                                                                    <Form.Label className="isRequired">Estágio</Form.Label>
                                                                    <Select
                                                                        id={`sgepfasedengue_${row.id}`}
                                                                        value={row.sgepfasedengue || null}
                                                                        onChange={(e: any) => {
                                                                            const analisados = [...this.state.analisados];
                                                                            analisados[index].sgepfasedengue = e;
                                                                            this.setState({ analisados });
                                                                        }}
                                                                        closeMenuOnSelect
                                                                        isClearable
                                                                        placeholder="Selecione o estágio"
                                                                        options={this.state.tubitType}
                                                                        isMulti={false}
                                                                    />
                                                                </Col>

                                                                <Col lg="3" xs="12" className="mb-2">
                                                                    <Form.Label className="isRequired">Espécie</Form.Label>
                                                                    <Select
                                                                        id={`sgepdengueespecie_${row.id}`}
                                                                        value={row.sgepdengueespecie || null}
                                                                        onChange={(e: any) => {
                                                                            const analisados = [...this.state.analisados];
                                                                            analisados[index].sgepdengueespecie = e;
                                                                            this.setState({ analisados });
                                                                        }}
                                                                        closeMenuOnSelect
                                                                        isClearable
                                                                        placeholder="Selecione a espécie"
                                                                        options={this.state.especies}
                                                                        isMulti={false}
                                                                    />
                                                                </Col>

                                                                <Col lg="3" xs="11" className="mb-2">
                                                                    <Form.Label className="isRequired">Tipo Depósito</Form.Label>
                                                                    <Select
                                                                        id={`sgepitensinspecaodengue_${row.id}`}
                                                                        value={row.sgepitensinspecaodengue || null}
                                                                        onChange={(e: any) => {
                                                                            const analisados = [...this.state.analisados];
                                                                            analisados[index].sgepitensinspecaodengue = e;
                                                                            this.setState({ analisados });
                                                                        }}
                                                                        closeMenuOnSelect
                                                                        isClearable
                                                                        placeholder="Selecione o tipo depósito"
                                                                        options={this.state.itensToInspect}
                                                                        isMulti={false}
                                                                    />
                                                                </Col>
                                                                <Col lg="1" xs="1" className="mb-2 mt-auto">
                                                                    {index > 0 && (
                                                                        <Button
                                                                            variant="danger"
                                                                            onClick={() => {
                                                                                const analisados = this.state.analisados.filter((_, i) => i !== index);
                                                                                this.setState({ analisados });
                                                                            }}
                                                                        >
                                                                            X
                                                                        </Button>
                                                                    )}
                                                                </Col>

                                                            </Row>
                                                        </Col>
                                                    ))}

                                                    <Col xs="12" className="text-end mt-3">
                                                        <Button
                                                            variant="primary"
                                                            onClick={() => {
                                                                this.setState((prev: any) => ({
                                                                    analisados: [
                                                                        ...(prev.analisados || []),
                                                                        {
                                                                            id: (prev.analisados?.length || 0) + 1,
                                                                            quantidade: '',
                                                                            sgepfasedengue: null,
                                                                            sgepdengueespecie: null,
                                                                            sgepitensinspecaodengue: null,
                                                                        },
                                                                    ],
                                                                }));
                                                            }}
                                                        >
                                                            Adicionar
                                                        </Button>
                                                    </Col>
                                                </>
                                            )}


                                        </Row>
                                    </Tab>
                                    <Tab eventKey="amostra_coletada" title="Amostras Coletadas">
                                        <Row className='mx-1'>
                                            <Col xs="12" className="bottom10 mt-2 mb-4">
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Analisado em laboratório"
                                                    checked={this.state.laboratoryAnalyzed}
                                                    onChange={() => this.setState({ laboratoryAnalyzed: !this.state.laboratoryAnalyzed })}
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="bottom10">
                                                <Form.Label>Inicial</Form.Label>
                                                <Form.Control
                                                    id="inicial_amostra"
                                                    type="number"
                                                    min={0}
                                                    {...(json['final_amostra'] ? {
                                                        max: Number(json['final_amostra'])
                                                    } : {})}
                                                    value={json['inicial_amostra'] || ''}
                                                    onChange={(e: any) => {
                                                        this.formEvent.onChange("varchar", e.target);
                                                        setTimeout(() => this.changeSpecimenInitialOrFinal(), 0);
                                                    }}
                                                    placeholder="Digite o valor inicial"
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="bottom10">
                                                <Form.Label>Final</Form.Label>
                                                <Form.Control
                                                    id="final_amostra"
                                                    type="number"
                                                    {...(json['inicial_amostra'] ? {
                                                        min: Number(json['inicial_amostra'])
                                                    } : {})}
                                                    value={json['final_amostra'] || ''}
                                                    onChange={(e: any) => {
                                                        this.formEvent.onChange("varchar", e.target);
                                                        setTimeout(() => this.changeSpecimenInitialOrFinal(), 0);
                                                    }}
                                                    placeholder="Digite o valor final"
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="bottom10">
                                                <Form.Label>Quantidade Tubitos</Form.Label>
                                                <Form.Control
                                                    id="quantidade_tubitos"
                                                    type="number"
                                                    min={0}
                                                    value={json['quantidade_tubitos'] || 0}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="bottom10">
                                                <Form.Label>Depósitos eliminados</Form.Label>
                                                <Form.Control
                                                    id="depositos_eliminados"
                                                    type="number"
                                                    min={0}
                                                    defaultValue={json['depositos_eliminados'] ? json['depositos_eliminados'] : ''}
                                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                    placeholder="Digite o número de depósitos eliminados"
                                                />
                                            </Col>
                                            <Col lg="4" xs="12" className="bottom10">
                                                <Form.Label >Número de Tratamentos</Form.Label>
                                                <Form.Control
                                                    id="num_tratamentos"
                                                    type="number"
                                                    min={0}
                                                    defaultValue={json['num_tratamentos'] ? json['num_tratamentos'] : ''}
                                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                    placeholder="Digite o número de tratamentos"
                                                />
                                            </Col>
                                            {this.state.amostras && this.state.amostras.map((amostra, index) => (
                                                <React.Fragment key={`amostra_${index}`}>
                                                    {!this.state.laboratoryAnalyzed ? (
                                                        <>
                                                            <Col lg="2" xs="12" className="bottom10">
                                                                <Form.Label>Nº Amostra</Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    value={amostra.numero ?? ''}
                                                                    disabled
                                                                />
                                                            </Col>

                                                            <Col lg="3" xs="12" className="bottom10 d-flex align-items-end">
                                                                <div style={{ flex: 1 }}>
                                                                    <Form.Label className="isRequired">Fase</Form.Label>
                                                                    <Select
                                                                        value={this.state.tubitType.find((opt) => opt.value === amostra.sgepfasedengue) || null}
                                                                        onChange={(e) => {
                                                                            const novas = [...this.state.amostras];
                                                                            novas[index].sgepfasedengue = e.value;
                                                                            this.setState({ amostras: novas });
                                                                        }}
                                                                        placeholder="Selecione"
                                                                        closeMenuOnSelect={true}
                                                                        options={this.state.tubitType}
                                                                        isMulti={false}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Col lg="12" className="mt-2">
                                                                <h6>Amostra número {amostra.numero}</h6>
                                                            </Col>

                                                            <Col lg="2" xs="12" className="bottom10">
                                                                <Form.Label className="isRequired">Fase</Form.Label>
                                                                <Select
                                                                    value={this.state.tubitType.find(opt => opt.value === amostra.sgepfasedengue) || null}
                                                                    onChange={(e) => {
                                                                        const novas = [...this.state.amostras];
                                                                        novas[index].sgepfasedengue = e.value;
                                                                        this.setState({ amostras: novas });
                                                                    }}
                                                                    options={this.state.tubitType}
                                                                    placeholder="Selecione"
                                                                    isMulti={false}
                                                                />
                                                            </Col>

                                                            <Col lg="2" xs="12" className="bottom10">
                                                                <Form.Label className={!amostra.mii ? 'isRequired' : ''}>Espécime</Form.Label>
                                                                <Select
                                                                    value={this.state.especies.find(opt => opt.value === amostra.sgepdengueespecie) || null}
                                                                    onChange={(e) => {
                                                                        const novas = [...this.state.amostras];
                                                                        novas[index].sgepdengueespecie = e.value;
                                                                        this.setState({ amostras: novas });
                                                                    }}
                                                                    disabled={!!amostra.mii}
                                                                    options={this.state.especies}
                                                                    placeholder="Selecione"
                                                                    isMulti={false}
                                                                />
                                                            </Col>

                                                            <Col lg="2" xs="12" className="mb-2">
                                                                <Form.Label className={!amostra.mii ? 'isRequired' : ''}>Nº Exemplares</Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    min={0}
                                                                    value={amostra.numeroexemplares ?? ''}
                                                                    onChange={(e) => {
                                                                        const novas = [...this.state.amostras];
                                                                        novas[index].numeroexemplares = parseInt(e.target.value) || 0;
                                                                        this.setState({ amostras: novas });
                                                                    }}
                                                                    placeholder="Digite o número de exemplares"
                                                                    disabled={amostra.mii}
                                                                />
                                                            </Col>

                                                            <Col lg="2" xs="12" className="bottom10">
                                                                <Form.Label className="isRequired">Data Entrada</Form.Label>
                                                                <Form.Control
                                                                    type="date"
                                                                    maxLength={10}
                                                                    value={amostra.dataentrada || ''}
                                                                    onChange={(e) => {
                                                                        const novas = [...this.state.amostras];
                                                                        novas[index].dataentrada = e.target.value;
                                                                        this.setState({ amostras: novas });
                                                                    }}
                                                                />
                                                            </Col>

                                                            <Col lg="2" xs="12" className="bottom10">
                                                                <Form.Label className={!amostra.mii ? 'isRequired' : ''}>Data Identificação</Form.Label>
                                                                <Form.Control
                                                                    type="date"
                                                                    maxLength={10}
                                                                    value={amostra.dataidentificacao || ''}
                                                                    onChange={(e) => {
                                                                        const novas = [...this.state.amostras];
                                                                        novas[index].dataidentificacao = e.target.value;
                                                                        this.setState({ amostras: novas });
                                                                    }}
                                                                    disabled={amostra.mii}
                                                                />
                                                            </Col>


                                                            <Col lg="2" xs="12" className="bottom10">
                                                                <Form.Label>Armadilha</Form.Label>
                                                                <Select
                                                                    value={this.state.trap.find(opt => opt.value === amostra.sgepdenguearmadilha) || null}
                                                                    onChange={(e: any) => {
                                                                        const novas = [...this.state.amostras];
                                                                        novas[index].sgepdenguearmadilha = e.value;
                                                                        this.setState({ amostras: novas });
                                                                    }}
                                                                    placeholder="Selecione"
                                                                    options={this.state.trap}
                                                                    isMulti={false}
                                                                />
                                                            </Col>

                                                            <Col lg="1" xs="12" className="mt-2 text-center">
                                                                <Form.Label>M.I.I</Form.Label>
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    checked={amostra.mii || false}
                                                                    onChange={() => {
                                                                        const novas = [...this.state.amostras];
                                                                        novas[index].mii = !novas[index].mii;
                                                                        this.setState({ amostras: novas });
                                                                    }}
                                                                />
                                                            </Col>

                                                            <Col lg="3" xs="12" className="bottom10">
                                                                <Form.Label className="isRequired">Laboratório</Form.Label>
                                                                <Select
                                                                    value={this.state.laboratories.find(opt => opt.value === amostra.sgeplaboratorio) || null}
                                                                    onChange={(e) => {
                                                                        const novas = [...this.state.amostras];
                                                                        novas[index].sgeplaboratorio = e.value;
                                                                        this.setState({ amostras: novas });
                                                                    }}
                                                                    options={this.state.laboratories}
                                                                    placeholder="Selecione"
                                                                    isMulti={false}
                                                                />
                                                            </Col>

                                                            <Col lg="3" xs="12" className="bottom10">
                                                                <Form.Label className="isRequired">Laboratorista</Form.Label>
                                                                <Select
                                                                    value={this.state.professional.find(opt => opt.value === amostra.idlaboratorista) || null}
                                                                    onChange={(e) => {
                                                                        const novas = [...this.state.amostras];
                                                                        novas[index].idlaboratorista = e?.value ?? null;
                                                                        this.setState({ amostras: novas });
                                                                    }}
                                                                    options={this.state.professional}
                                                                    placeholder="Selecione"
                                                                    isMulti={false}
                                                                />
                                                            </Col>

                                                            <Col lg="4" xs="11" className="bottom10">
                                                                <Form.Label>Observação</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={amostra.observacao || ''}
                                                                    onChange={(e) => {
                                                                        const novas = [...this.state.amostras];
                                                                        novas[index].observacao = e.target.value;
                                                                        this.setState({ amostras: novas });
                                                                    }}
                                                                    placeholder="Digite a observação"
                                                                />
                                                            </Col>
                                                        </>
                                                    )}

                                                    <Col lg="1" xs="1" className="bottom10 d-flex align-items-end">
                                                        {(index === 0 || index === this.state.amostras.length - 1) && (
                                                            <Button
                                                                variant="danger"
                                                                onClick={() => {
                                                                    const novas = [...this.state.amostras];
                                                                    novas.splice(index, 1);

                                                                    let novoInicial = '';
                                                                    let novoFinal = '';

                                                                    if (novas.length > 0) {
                                                                        const numeros = novas.map(a => a.numero).filter(n => n !== null && n !== undefined);
                                                                        if (numeros.length > 0) {
                                                                            novoInicial = String(Math.min(...numeros));
                                                                            novoFinal = String(Math.max(...numeros));
                                                                        }
                                                                    }

                                                                    // Atualiza amostras e campos inicial/final
                                                                    this.setState({ amostras: novas }, () => {
                                                                        this.formEvent.onChange('varchar', { id: 'inicial_amostra', value: novoInicial });
                                                                        this.formEvent.onChange('varchar', { id: 'final_amostra', value: novoFinal });
                                                                    });
                                                                }}
                                                            >
                                                                X
                                                            </Button>

                                                        )}
                                                    </Col>
                                                </React.Fragment>
                                            ))}
                                        </Row>
                                    </Tab>
                                    <Tab eventKey="tratamento" title="Tratamentos">
                                        <Row className='mx-1'>
                                            <Col lg="12" className="bottom10">
                                                <h5>Focal</h5>
                                            </Col>
                                            {/* Larvicida 1 */}
                                            <Col lg="6">
                                                <h6>Larvicida (1)</h6>
                                                <Row>
                                                    <Col lg="4" xs="12" className="mb-2">
                                                        <Form.Label>Veneno</Form.Label>
                                                        <Select
                                                            id="trat1.sgepveneno"
                                                            value={this.getSelectedOption(json['trat1.sgepveneno'])}
                                                            onChange={(e: any) => {
                                                                if (e === null) {
                                                                    this.formEvent.onChange("select", null, "trat1.sgepveneno");
                                                                    json['trat1.quantidade'] = ""
                                                                    json['trat1.numdepositostratados'] = ""
                                                                } else {
                                                                    this.formEvent.onChange("select", e, "trat1.sgepveneno");
                                                                }
                                                            }}
                                                            closeMenuOnSelect={true}
                                                            isClearable={true}
                                                            placeholder="Selecione"
                                                            options={this.state.poison}
                                                            isMulti={false}
                                                        />
                                                    </Col>
                                                    <Col lg="3" xs="12" className="mb-2">
                                                        <Form.Label className={`${json['trat1.sgepveneno'] ? 'isRequired' : ''}`}>Quantidade (g)</Form.Label>
                                                        <Form.Control
                                                            id="trat1.quantidade"
                                                            type="number"
                                                            min={0}
                                                            value={json['trat1.quantidade'] || ''}
                                                            onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                            placeholder="Digite a quantidade"
                                                        />
                                                    </Col>
                                                    <Col lg="3" xs="12" className="mb-2">
                                                        <Form.Label className={`${json['trat1.sgepveneno'] ? 'isRequired' : ''}`}>Depósitos tratados</Form.Label>
                                                        <Form.Control
                                                            id="trat1.numdepositostratados"
                                                            type="number"
                                                            min={0}
                                                            value={json['trat1.numdepositostratados'] || ''}
                                                            onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                            placeholder="Digite o número de depósitos tratados"
                                                        />
                                                    </Col>
                                                    <Col lg="2" xs="12" className="text-center mb-2">
                                                        <Form.Label>BRI</Form.Label>
                                                        <Form.Check
                                                            id="trat1.bri"
                                                            type="checkbox"
                                                            checked={json['trat1.bri'] === true || json['trat1.bri'] === 'S'}
                                                            onChange={(e: any) => {
                                                                const checked = e.target.checked;
                                                                this.setState((prev: any) => ({
                                                                    json: {
                                                                        ...prev.json,
                                                                        ['trat1.bri']: checked
                                                                    },
                                                                }));
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            {/* Larvicida 2 */}
                                            <Col lg="6">
                                                <h6>Larvicida (2)</h6>
                                                <Row>
                                                    <Col lg="4" xs="12" className="mb-2">
                                                        <Form.Label>Veneno</Form.Label>
                                                        <Select
                                                            id="trat2.sgepveneno"
                                                            value={this.getSelectedOption(json['trat2.sgepveneno'])}
                                                            onChange={(e: any) => {
                                                                if (e === null) {
                                                                    this.formEvent.onChange("select", null, "trat2.sgepveneno");
                                                                    json['trat2.quantidade'] = ""
                                                                    json['trat2.numdepositostratados'] = ""
                                                                } else {
                                                                    this.formEvent.onChange("select", e, "trat2.sgepveneno");
                                                                }
                                                            }}
                                                            closeMenuOnSelect={true}
                                                            isClearable={true}
                                                            placeholder="Selecione"
                                                            options={this.state.poison}
                                                            isMulti={false}
                                                        />
                                                    </Col>
                                                    <Col lg="3" xs="12" className="mb-2">
                                                        <Form.Label className={`${json['trat2.sgepveneno'] ? 'isRequired' : ''}`}>Quantidade (g)</Form.Label>
                                                        <Form.Control
                                                            id="trat2.quantidade"
                                                            type="number"
                                                            min={0}
                                                            value={json['trat2.quantidade'] || ''}
                                                            onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                            placeholder="Digite a quantidade"
                                                        />
                                                    </Col>
                                                    <Col lg="3" xs="12" className="mb-2">
                                                        <Form.Label className={`${json['trat2.sgepveneno'] ? 'isRequired' : ''}`}>Depósitos tratados</Form.Label>
                                                        <Form.Control
                                                            id="trat2.numdepositostratados"
                                                            type="number"
                                                            min={0}
                                                            value={json['trat2.numdepositostratados'] || ''}
                                                            onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                            placeholder="Digite o número de depósitos tratados"
                                                        />
                                                    </Col>
                                                    <Col lg="2" xs="12" className="text-center mb-2">
                                                        <Form.Label>BRI</Form.Label>
                                                        <Form.Check
                                                            id="trat2.bri"
                                                            type="checkbox"
                                                            checked={json['trat2.bri'] === true || json['trat2.bri'] === 'S'}
                                                            onChange={(e: any) => {
                                                                const checked = e.target.checked;
                                                                this.setState((prev: any) => ({
                                                                    json: {
                                                                        ...prev.json,
                                                                        ['trat2.bri']: checked
                                                                    },
                                                                }));
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col lg="12" className="mt-5">
                                                <h5>Perifocal</h5>
                                            </Col>
                                            <Col lg="6">
                                                <h6>Adulticida</h6>
                                                <Row>
                                                    <Col lg="4" xs="12" className="mb-2">
                                                        <Form.Label>Veneno</Form.Label>
                                                        <Select
                                                            id="trat3.sgepveneno"
                                                            value={this.getSelectedOption(json['trat3.sgepveneno'])}
                                                            onChange={(e: any) => {
                                                                if (e === null) {
                                                                    this.formEvent.onChange("select", null, "trat3.sgepveneno");
                                                                    json['trat3.quantidade'] = ""
                                                                } else {
                                                                    this.formEvent.onChange("select", e, "trat3.sgepveneno");
                                                                }
                                                            }}
                                                            closeMenuOnSelect={true}
                                                            isClearable={true}
                                                            placeholder="Selecione"
                                                            options={this.state.poison}
                                                            isMulti={false}
                                                        />
                                                    </Col>
                                                    <Col lg="3" xs="12" className="mb-2">
                                                        <Form.Label className={`${json['trat3.sgepveneno'] ? 'isRequired' : ''}`}>Quantidade (cargas)</Form.Label>
                                                        <Form.Control
                                                            id="trat3.quantidade"
                                                            type="number"
                                                            min={0}
                                                            value={json['trat3.quantidade'] || ''}
                                                            onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                            placeholder="Digite a quantidade"
                                                        />
                                                    </Col>
                                                    <Col lg="1" xs="12" className="text-center mb-2">
                                                        <Form.Label>BRI</Form.Label>
                                                        <Form.Check
                                                            id="trat3.bri"
                                                            type="checkbox"
                                                            checked={json['trat3.bri'] === true || json['trat3.bri'] === 'S'}
                                                            onChange={(e: any) => {
                                                                const checked = e.target.checked;
                                                                this.setState((prev: any) => ({
                                                                    json: {
                                                                        ...prev.json,
                                                                        ['trat3.bri']: checked
                                                                    },
                                                                }));
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Tab>
                                    <Tab eventKey="armadilha" title="Armadilha">
                                        <Row className='mx-1'>
                                            <Col lg="2" xs="12" className="bottom10">
                                                <Form.Label className={!!(json['datainstalacao'] || json['numeroarmadilha'] || json['datacoleta'] || json['quantidadeovos']) ? 'isRequired' : ''}>Armadilha</Form.Label>
                                                <Select
                                                    value={this.getSelectedOption(json['sgepdenguearmadilha'])}
                                                    onChange={(e: any) => {
                                                        this.formEvent.onChange("select", e, "sgepdenguearmadilha");
                                                    }}
                                                    placeholder="Selecione"
                                                    options={this.state.trap}
                                                    isMulti={false}
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="mb-2">
                                                <Form.Label className={!!(json['sgepdenguearmadilha'] || json['datainstalacao'] || json['datacoleta'] || json['quantidadeovos']) ? 'isRequired' : ''}>Número da Armadilha</Form.Label>
                                                <Form.Control
                                                    id="numeroarmadilha"
                                                    type="text"
                                                    value={json['numeroarmadilha'] || ''}
                                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                    placeholder="Digite o numero da armadilha"
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="bottom10">
                                                <Form.Label className={!!(json['sgepdenguearmadilha'] || json['numeroarmadilha'] || json['datacoleta'] || json['quantidadeovos']) ? 'isRequired' : ''}>Data Instalação</Form.Label>
                                                <Form.Control
                                                    id="datainstalacao"
                                                    type="date"
                                                    value={json['datainstalacao'] ? json['datainstalacao'] : ''}
                                                    onChange={(e: any) => {
                                                        this.formEvent.onChange("date", e.target)
                                                    }}
                                                    placeholder="Data de instalação"
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="bottom10">
                                                <Form.Label className={!!(json['sgepdenguearmadilha'] || json['numeroarmadilha'] || json['datainstalacao'] || json['quantidadeovos']) ? 'isRequired' : ''}>Data Coleta</Form.Label>
                                                <Form.Control
                                                    id="datacoleta"
                                                    type="date"
                                                    value={json['datacoleta'] ? json['datacoleta'] : ''}
                                                    onChange={(e: any) => {
                                                        this.formEvent.onChange("date", e.target)
                                                    }}
                                                    placeholder="Data de coleta"
                                                />
                                            </Col>
                                            <Col lg="2" xs="12" className="mb-2">
                                                <Form.Label className={!!(json['sgepdenguearmadilha'] || json['numeroarmadilha'] || json['datacoleta'] || json['datainstalacao']) ? 'isRequired' : ''}>Quantidade de Ovos</Form.Label>
                                                <Form.Control
                                                    id="quantidadeovos"
                                                    type="number"
                                                    min={0}
                                                    value={json['quantidadeovos'] || ''}
                                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                    placeholder="Digite a quantidade de ovos"
                                                />
                                            </Col>
                                        </Row>
                                    </Tab>
                                    <Tab eventKey="assistentes" title="Assistentes">
                                        <Row className='bottom10 mx-1'>

                                            <Col xs="12" className="bottom10">
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Incluir profissionais"
                                                    checked={this.state.includeAssistants}
                                                    onChange={() => this.setState({ includeAssistants: !this.state.includeAssistants })}
                                                />
                                            </Col>
                                            {this.state.includeAssistants && (
                                                <Col lg="12" xs="12">
                                                    <Form.Label className='isRequired'>Outros Profissionais</Form.Label>
                                                    <Select
                                                        id="agentAssistants"
                                                        value={Array.isArray((this.state.json as any).agentAssistants) ? (this.state.json as any).agentAssistants : []}
                                                        onChange={(selected) => {
                                                            this.setState((prevState: any) => ({
                                                                json: {
                                                                    ...prevState.json,
                                                                    agentAssistants: selected || []
                                                                }
                                                            }));
                                                        }}
                                                        closeMenuOnSelect={false}
                                                        placeholder="Selecione"
                                                        options={this.state.professional.filter(
                                                            (opt) => opt.value !== ((this.state.json as any)?.sgepusuariocargo ?? null)
                                                        )}
                                                        isMulti={true}
                                                    />
                                                </Col>
                                            )}
                                        </Row>

                                    </Tab>
                                    {json['idsupervisor'] && (
                                        <Tab eventKey="supervisor" title="Supervisor">
                                            {json['idsupervisor'] && (
                                                <Col lg="4" xs="12" className="bottom10">
                                                    <Form.Label>Supervisor</Form.Label>
                                                    <Select
                                                        id="idsupervisor"
                                                        value={this.formEvent.onValueSelect('select', 'idsupervisor', this.state.supervisor)}
                                                        onChange={(e: any) => this.formEvent.onChange("select", e, "idsupervisor")}
                                                        closeMenuOnSelect={true}
                                                        placeholder={"Selecione"}
                                                        options={this.state.supervisor}
                                                        isMulti={false}
                                                        isDisabled={true}
                                                    />
                                                </Col>)}
                                        </Tab>)}
                                </Tabs>
                            }
                            <Row>
                                <Col xs="12" style={{ marginTop: 20 }}>
                                    <Button className="buttonSave" type="button" onClick={(e: any) => this.save()} variant="primary">
                                        <Image className="imageSave"
                                            src={salvar} />
                                        Salvar
                                    </Button>
                                    <Button onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)} className="buttonCancel" variant="link">Cancelar</Button>
                                </Col>
                            </Row>
                        </Form>
                        <ToastContainer />
                    </Container>
                </div>
                <LoaderComponente show={this.state.isLoading} hide={() => this.setState({ isLoading: this.state.isLoading })} />
            </div >
        )
    }
    private setKeyFK() {
        var json = this.state.json as any
        json['data'] = moment(new Date()).format('DD/MM/YYYY')
        json['hora'] = moment(new Date()).format('HH:mm')
        if (this.props.idPoint) {
            json['sgeppontos'] = this.props.idPoint
        }

        if (this.props.idShape) {
            json['sshape'] = this.props.idShape
        }

        if (this.props.idAdminProcess) {
            json['sgepprocessoadministrativo'] = this.props.idAdminProcess
        }

        if (this.props.idProperty) {
            json['sgeppropriedade'] = this.props.idProperty
        }

        if (this.props.idPropertyBuilding) {
            json['sgeppropedificacoes'] = this.props.idPropertyBuilding
        }

        this.setState({ json })
    }

    private loadProfessional() {
        this.props.viewModel.fetchProfessional().then((rs) => {
            var result = rs as Array<any>
            var array = Array<any>()

            for (var i = 0; i < result.length; i++) {
                var item = result[i]
                array.push({ value: item.id, label: item.value, check: false })
            }

            this.setState({
                professional: array,
                supervisor: array
            })
        });
    }

    private onChangeGroupVisitReason(e: any) {
        this.loadVisitReason(e.value)
        this.formEvent.onChange("select", e, "sgepgrupomotivovisita")
    }

    private loadVisitReason(id: number) {
        this.props.viewModel.fetchVisitReason(id).then((rs) => {
            var result = rs as Array<any>
            var array = Array<any>()

            for (var i = 0; i < result.length; i++) {
                var item = result[i]
                array.push({ value: item.id, label: item.value, check: false })
            }

            this.setState({
                visitReason: array
            })
        });
    }

    private async loadInfos() {
        const json = this.state.json as any;
        const jsonObj = {
            sgeppontos: json.sgeppontos,
            sshape: json.sshape,
            sgepprocessoadministrativo: json.sgepprocessoadministrativo,
            sgeppropriedade: json.sgeppropriedade,
            sgeppropedificacoes: json.sgeppropedificacoes,
        }
        if (!json['sgepvisita']) {
            const dados = await this.props.viewModel.fetchBasicInfo(jsonObj);
            if (!dados) {
                return
            }
            const novoJson = { ...this.state.json, ...dados[0] };
            this.setState({ json: novoJson });
            const municipio = dados[0]?.municipio;

            if (!municipio) {
                return;
            }

            const municipios = await this.loadMunicipalities(municipio);

            const municipioSelecionado = municipios.find(
                (m: any) => m.label.toLowerCase() === municipio.toLowerCase()
            );

            if (municipioSelecionado) {
                this.setState((prevState: any) => ({
                    json: {
                        ...prevState.json,
                        ccidade: municipioSelecionado.value,
                    },
                    municipality: municipios,
                }));
            }
        }
    }


    private onChangeVisitReason(e: any) {
        if (e.label.includes("Endemia")) {
            this.loadEndemicLists()
            this.loadInfos()
            this.setState({ isEndemic: true })
        } else {
            this.setState({ isEndemic: false })
        }
        this.formEvent.onChange("select", e, "sgepmotivovisita")
    }

    private save() {
        var json = this.state.json as any
        if (json["data"] == undefined || json["hora"] == undefined || json["sgepusuariocargo"] == undefined) {
            this.showFieldsEmpty("Campos obrigatórios não preenchidos!")
            return
        }

        var date = moment(json["data"], "DD/MM/YYYY")
        if (!date.isValid()) {
            this.showFieldsEmpty("Data inválida!")
            return
        }

        var hour = moment(json["hora"], "HH:mm")
        if (!hour.isValid()) {
            this.showFieldsEmpty("Hora inválida!")
            return false
        }

        if (date.diff(new Date()) > 0) {
            this.showFieldsEmpty("Data inválida!")
            return
        }
        if (this.state.isEndemic) {
            json['ano'] = moment().format('YYYY')
            delete json['idsupervisor']
            if (json['sem_numero']) {
                json['numero'] = null
            }
            if (this.state.laboratoryAnalyzed) {
                json['analisado'] = true;
            } else {
                json['analisado'] = false;
            }

            const depositos: any[] = [];

            for (const item of this.state.analisados) {
                const { quantidade, sgepfasedengue, sgepdengueespecie, sgepitensinspecaodengue } = item;

                // Validação dos campos obrigatórios
                if (
                    quantidade === '' ||
                    quantidade === null ||
                    quantidade === undefined ||
                    !sgepfasedengue ||
                    !sgepdengueespecie ||
                    !sgepitensinspecaodengue
                ) {
                    this.showFieldsEmpty('Campos obrigatórios não preenchidos2!');
                    return;
                }

                depositos.push({
                    quantidade: Number(quantidade),
                    sgepfasedengue: sgepfasedengue.value,
                    sgepdengueespecie: sgepdengueespecie.value,
                    sgepitensinspecaodengue: sgepitensinspecaodengue.value,
                });
            }

            json['depositoinspecionado'] = depositos;

            //Verifica se as amostras estão validas, caso contrario, Exibe o erro
            const amostrasInvalidas = this.state.amostras.some((a, i) => {
                if (!json.sgepvisitadengue || !this.state.laboratoryAnalyzed) {
                    return !a.sgepfasedengue;
                }

                // Quando editando:
                const faseObrigatoria = !a.sgepfasedengue;
                const laboratorioObrigatorio = !a.sgeplaboratorio;
                const laboratoristaObrigatorio = !a.idlaboratorista;
                const dataEntradaObrigatoria = !a.dataentrada;

                if (a.mii) {
                    return (
                        faseObrigatoria ||
                        laboratorioObrigatorio ||
                        laboratoristaObrigatorio ||
                        dataEntradaObrigatoria
                    );
                } else {
                    const especieObrigatoria = !a.sgepdengueespecie;
                    const exemplaresObrigatorio = a.numeroexemplares == null || a.numeroexemplares === '';
                    const dataIdentificacaoObrigatoria = !a.dataidentificacao;

                    return (
                        faseObrigatoria ||
                        laboratorioObrigatorio ||
                        laboratoristaObrigatorio ||
                        dataEntradaObrigatoria ||
                        especieObrigatoria ||
                        exemplaresObrigatorio ||
                        dataIdentificacaoObrigatoria
                    );
                }
            });

            if (!json['ccidade'] ||
                !json['sgepnomelocalidade'] ||
                !json['sgepcategorialocalidade'] ||
                !json['sgepzona'] ||
                !json['sgeptipolocal'] ||
                !json['ciclo'] ||
                !json['ano'] ||
                !json['sgepatividadedengue'] ||
                !json['numeroquadra'] ||
                !json['lado'] ||
                !json['logradouro'] ||
                !json['indice_imovel'] ||
                !json['complemento'] ||
                !json['sgeptipoimovel'] ||
                !json['sgeptipovisita'] ||
                (!json['numero'] && !json['sem_numero']) ||
                (!json['inicial_amostra'] && json['final_amostra']) ||
                (json['inicial_amostra'] && !json['final_amostra']) ||
                (json['trat1.sgepveneno'] && (!json['trat1.quantidade'] || !json['trat1.numdepositostratados'])) ||
                (json['trat2.sgepveneno'] && (!json['trat2.quantidade'] || !json['trat2.numdepositostratados'])) ||
                (json['trat3.sgepveneno'] && !json['trat3.quantidade']) ||
                amostrasInvalidas ||
                (this.state.includeAssistants && !json['agentAssistants'].length)
            ) {
                this.showFieldsEmpty("Campos obrigatórios não preenchidos!")
                return
            }
            const hasTrapData =
                json['sgepdenguearmadilha'] ||
                json['numeroarmadilha'] ||
                json['datainstalacao'] ||
                json['datacoleta'] ||
                json['quantidadeovos'];

            if (hasTrapData) {
                const requiredFields = [
                    'sgepdenguearmadilha',
                    'numeroarmadilha',
                    'datainstalacao',
                    'datacoleta',
                    'quantidadeovos'
                ];

                const missing = requiredFields.filter(f => !json[f]);
                if (missing.length > 0) {
                    toast.error('Preencha todos os campos de armadilha antes de salvar.', {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                    return;
                }

                json['armadilhas'] = {
                    sgepdenguevisitaarmadilha: json['sgepdenguevisitaarmadilha'] ?? null,
                    sgepdenguearmadilha: json['sgepdenguearmadilha'],
                    numeroarmadilha: json['numeroarmadilha'],
                    datainstalacao: json['datainstalacao'],
                    datacoleta: json['datacoleta'],
                    quantidadeovos: json['quantidadeovos'],
                };
            } else {
                json['armadilhas'] = null;
            }


            json['amostras'] = this.state.amostras.map((a) => {
                const base = {
                    numero: a.numero,
                    sgepfasedengue: a.sgepfasedengue,
                    sgepdengueamostracoletada: a.sgepdengueamostracoletada,
                    sgepdengueespecie: null,
                    numeroexemplares: null,
                    dataentrada: null,
                    dataidentificacao: null,
                    sgepdenguearmadilha: null,
                    mii: false,
                    sgeplaboratorio: null,
                    sgepusuariocargo: null,
                    observacao: null
                };

                if (this.state.laboratoryAnalyzed) {
                    return {
                        ...base,
                        sgepdengueespecie: a.sgepdengueespecie || null,
                        numeroexemplares: a.numeroexemplares ?? null,
                        dataentrada: a.dataentrada || null,
                        dataidentificacao: a.dataidentificacao || null,
                        sgepdenguearmadilha: a.sgepdenguearmadilha || null,
                        mii: !!a.mii,
                        sgeplaboratorio: a.sgeplaboratorio || null,
                        sgepusuariocargo: a.idlaboratorista || null,
                        observacao: a.observacao || null
                    };
                }

                return base;
            });

            // Consolidando os tratamentos
            const tratamentoDengue: any = [];

            ['trat1', 'trat2', 'trat3'].forEach((prefix, index) => {
                if (json[`${prefix}.sgepveneno`]) {
                    tratamentoDengue.push({
                        sgeptratamentodengue: json[`${prefix}.sgeptratamentodengue`] ?? null,
                        sgepveneno: json[`${prefix}.sgepveneno`],
                        quantidade: json[`${prefix}.quantidade`],
                        numdepositostratados: json[`${prefix}.numdepositostratados`],
                        bri: json[`${prefix}.bri`],
                        ordem: index + 1
                    });
                }
            });
            json['tratamentoDengue'] = tratamentoDengue;
            Object.keys(json).forEach(key => {
                if (key.startsWith('trat1.') || key.startsWith('trat2.') || key.startsWith('trat3.')) {
                    delete json[key];
                }
            });

        }
        console.log('Enviando', json)
        this.props.viewModel.fetchSave(json, this.state.isEndemic).then(() => {
            toast.success("Registro incluído com sucesso!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            setTimeout(() => {
                this.props.delegate.tapDimiss(this.props.navigation);
            }, 1000);
        }, e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        })
    }

    private showFieldsEmpty(message: string) {
        toast.error(message, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    }

    private async loadStruct() {
        const json = this.state.json as any;
        json['sgepvisita'] = this.props.idPrimary;
        this.setState({ isLoading: true });

        try {
            const rs = await this.props.viewModel.fetchDataOne(json);
            const resultado = rs as Array<any>;
            if (resultado.length === 0) {
                this.setState({ isLoading: false });
                return;
            }

            const result = resultado[0];

            // Formatações básicas
            result['data'] = result['data'] ? moment(result['data']).format('DD/MM/YYYY') : '';
            result['hora'] = result['hora'] ? moment(result['hora'], 'HH:mm:ss').format('HH:mm') : '';

            // Carrega motivo da visita
            if (result['sgepgrupomotivovisita'] !== undefined) {
                await this.loadVisitReason(result['sgepgrupomotivovisita']);
            }

            // Define se analisado
            this.setState({ laboratoryAnalyzed: !!result['analisado'] });

            // Armadilha
            const armadilha = result.armadilhas;
            if (armadilha) {
                result['sgepdenguevisitaarmadilha'] = armadilha.sgepdenguevisitaarmadilha ?? null;
                result['sgepdenguearmadilha'] = armadilha.sgepdenguearmadilha ?? null;
                result['numeroarmadilha'] = armadilha.numeroarmadilha ?? '';
                result['datainstalacao'] = armadilha.datainstalacao ? moment(armadilha.datainstalacao).format('YYYY-MM-DD') : '';
                result['datacoleta'] = armadilha.datacoleta ? moment(armadilha.datacoleta).format('YYYY-MM-DD') : '';
                result['quantidadeovos'] = armadilha.quantidadeovos ?? '';
            }

            await this.loadEndemicLists();

            let analisados = this.state.analisados;
            const depositoinspecionado = result.depositoinspecionado;
            if (depositoinspecionado && depositoinspecionado.length > 0) {
                analisados = depositoinspecionado.map((item: any, index: number) => ({
                    id: index + 1,
                    quantidade: item.quantidade,
                    sgepfasedengue: this.state.tubitType.find((opt: any) => opt.value === item.sgepfasedengue) || null,
                    sgepdengueespecie: this.state.especies.find((opt: any) => opt.value === item.sgepdengueespecie) || null,
                    sgepitensinspecaodengue: this.state.itensToInspect.find((opt: any) => opt.value === item.sgepitensinspecaodengue) || null,
                }));
            }

            const newState: any = {
                json: result,
                analisados,
                includeAssistants: result.agentAssistants?.length > 0,
                isEndemic: result.gepmotivovisita?.includes('Endemia') || false,
            };

            if (result.ccidade) {
                newState.municipality = [{
                    value: result.ccidade,
                    label: result.municipio,
                }];
            }

            if (result.amostras && result.amostras.length && newState.isEndemic) {
                newState.amostras = result.amostras.map((a: any) => ({
                    sgepdengueamostracoletada: a.sgepdengueamostracoletada,
                    numero: a.numero,
                    sgepfasedengue: a.sgepfasedengue,
                    sgepdengueespecie: a.sgepdengueespecie ?? null,
                    numeroexemplares: a.numeroexemplares,
                    dataentrada: a.dataentrada,
                    dataidentificacao: a.dataidentificacao,
                    sgepdenguearmadilha: a.sgepdenguearmadilha,
                    mii: a.mii,
                    sgeplaboratorio: a.sgeplaboratorio,
                    idlaboratorista: a.idlaboratorista,
                    observacao: a.observacao,
                }));
            }

            this.setState(newState, () => {
                if (newState.isEndemic) {
                    this.changeSpecimenInitialOrFinal();
                }
            });

        } catch (e) {
            console.log('Erro ->', e)
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
        } finally {
            this.setState({ isLoading: false });
        }
    }


    private loadGroupVisitReason() {
        this.props.viewModel.fetchGroupVisitReason().then((rs) => {
            var result = rs as Array<any>
            var array = Array<any>()

            for (var i = 0; i < result.length; i++) {
                var item = result[i]
                array.push({ value: item.id, label: item.value, check: false })
            }

            this.setState({
                groupVisitReason: array
            })
        });
    }

    private async loadEndemicLists() {
        this.setState({ isLoading: true });
        const json = this.state.json as any
        const resultLocalityName = await this.props.viewModel.fetchLocalityName();
        const localityName = resultLocalityName.map((item: any) => ({
            value: item.id,
            label: item.value,
            check: false
        }));

        const resultLocalityCategory = await this.props.viewModel.fetchLocalityCategory();
        const localityCategory = resultLocalityCategory.map((item: any) => ({
            value: item.id,
            label: item.value,
            check: false
        }));

        const resultLocalType = await this.props.viewModel.fetchLocalType();
        const localType = resultLocalType.map((item: any) => ({
            value: item.id,
            label: item.value,
            check: false
        }));

        const resultPropertyType = await this.props.viewModel.fetchPropertyType();
        const propertyType = resultPropertyType.map((item: any) => ({
            value: item.id,
            label: item.value,
            check: false
        }));

        const resultVisitType = await this.props.viewModel.fetchVisitType();
        const visitType = resultVisitType.map((item: any) => ({
            value: item.id,
            label: item.value,
            check: false
        }));

        const resultPoison = await this.props.viewModel.fetchPoison();
        const poison = resultPoison.map((item: any) => ({
            value: item.id,
            label: item.value,
            check: false
        }));

        const resultActivity = await this.props.viewModel.fetchDengueActivity();
        const activity = resultActivity.map((item: any) => ({
            value: item.id,
            label: item.value,
            check: false
        }));

        const resultPendencyReason = await this.props.viewModel.fetchPendencyReason();
        const pendencyReason = resultPendencyReason.map((item: any) => ({
            value: item.id,
            label: item.value,
            check: false
        }));

        const resultItensToInspect = await this.props.viewModel.fetchItensToInspect();
        const itensToInspect = resultItensToInspect.map((item: any) => ({
            value: item.id,
            label: `${item.value} - ${item.nome}`,
            name: item.nome,
            check: false
        }));

        const resultZona = await this.props.viewModel.fetchZone();
        const zona = resultZona.map((item: any) => ({
            value: item.id,
            label: item.value,
            check: false
        }));

        const resultTubitType = await this.props.viewModel.fetchTubitType();
        const tubitType = resultTubitType.map((item: any) => ({
            value: item.id,
            label: item.value,
            check: false
        }));
        const resultTrap = await this.props.viewModel.fetchTrap();
        const trap = resultTrap.map((item: any) => ({
            value: item.id,
            label: item.value,
            check: false
        }));

        const resultLaboratories = await this.props.viewModel.fetchLaboratories();
        const laboratories = resultLaboratories.map((item: any) => ({
            value: item.id,
            label: item.value,
            check: false
        }));

        let newJson = {
            ...this.state.json
        }
        if (!json['ccidade']) {
            await this.props.viewModel.fetchMainMunicipality().then(async (result) => {
                if (!result) {
                    return null
                }
                const nomeMunicipio = result[0].municipio.split('-')[1]?.trim();
                await this.loadMunicipalities(nomeMunicipio);

                newJson = {
                    ...newJson,
                    ccidade: result[0].scidade ?? null,
                    municipio: result[0].municipio ?? null,
                }
            });
        }
        const resultSpecies = await this.props.viewModel.fetchSpecies();
        const especies = resultSpecies.map((item: any) => ({
            value: item.id,
            label: item.value,
            check: false
        }));

        this.setState({
            localityName,
            localityCategory,
            localType,
            propertyType,
            visitType,
            poison,
            activity,
            pendencyReason,
            itensToInspect,
            zona,
            tubitType,
            especies,
            trap,
            laboratories,
            json: newJson,
            isLoading: false
        });
    }

    private changeSpecimenInitialOrFinal = () => {
        const json = { ...this.state.json } as any;
        const amostrasAtuais = this.state.amostras || [];

        const inicialRaw = (this.state.json as any)['inicial_amostra'];
        const finalRaw = json['final_amostra'];
        const inicialOriginal = inicialRaw !== undefined && inicialRaw !== null && inicialRaw !== '' ? parseInt(inicialRaw) : NaN;
        const finalDigitado = finalRaw !== undefined && finalRaw !== null && finalRaw !== '' ? parseInt(finalRaw) : NaN;

        if (!inicialOriginal || !finalDigitado) {
            return
        }

        if (isNaN(inicialOriginal) && isNaN(finalDigitado) || (inicialOriginal === 0 && finalDigitado === 0)) {
            json['quantidade_tubitos'] = null;
        } else if (isNaN(inicialOriginal) || isNaN(finalDigitado)) {
            json['quantidade_tubitos'] = 1;
        } else if (inicialOriginal === finalDigitado) {
            json['quantidade_tubitos'] = 1;
        } else {
            json['quantidade_tubitos'] = finalDigitado - inicialOriginal + 1;
        }

        if ((isNaN(inicialOriginal) && isNaN(finalDigitado)) || (inicialOriginal === 0 && finalDigitado === 0)) {
            this.setState({ json, amostras: [] });
        }

        else if (!isNaN(inicialOriginal) && !isNaN(finalDigitado) && finalDigitado >= inicialOriginal && (inicialOriginal !== 0 && finalDigitado !== 0)) {
            const novasAmostras = [];

            for (let i = inicialOriginal; i <= finalDigitado; i++) {
                const jaExiste = amostrasAtuais.some(a => a.numero === i);
                if (!jaExiste) {
                    novasAmostras.push({ numero: i, sgepfasedengue: '' });
                }
            }

            const amostrasFiltradas = amostrasAtuais.filter(a => a.numero >= inicialOriginal && a.numero <= finalDigitado);
            const amostrasAtualizadas = [...amostrasFiltradas, ...novasAmostras].sort((a, b) => a.numero - b.numero);

            this.setState({ json, amostras: amostrasAtualizadas });
        }

        else {
            this.setState({ json });
        }
    };

    public loadMunicipalities = (() => {
        const debounced = debounce(async (inputValue: string, resolve: (options: any[]) => void) => {
            if (!inputValue) {
                resolve([]); // retorna vazio se não tiver valor
                return;
            }

            const result = await this.props.viewModel.fetchMunicipality(inputValue);
            const formatted = result.map((item: any) => ({
                value: item.id,
                label: item.value,
            }));
            this.setState({ municipality: formatted });
            resolve(formatted);
        }, 500);

        return (inputValue: string): Promise<any[]> => {
            return new Promise((resolve) => {
                debounced(inputValue, resolve);
            });
        };
    })();


}